export default __webpack_public_path__ + "static/Thursday-a88824a0b13f97f01c6ca824e329e122.png";